import Logger from '@utils/log'
import config from '@/config'
import { stripeConfigs } from '@constants/stripe'
import { useState, useEffect, useMemo } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import { theme as storeTheme, remoteConfig as storeRemoteConfig } from '@store'
import * as actions from '@actions'
import CircleSpinner from '@components/shared/CircleSpinner'
import { useWireValue } from '@forminator/react-wire'
import { debounceAsync } from '@utils'

const log = new Logger('StripeElementsWrap')

export const StripeElementsWrap = ({
    children,
}) => {
    
    const theme = useWireValue(storeTheme)
    const [clientSecret, setClientSecret] = useState(null)
    const [stripePromise, setStripePromise] = useState(null)
    
    const remoteConfig = useWireValue(storeRemoteConfig)
    
    // Prevent creating multiple setup intents
    const fetchClientSecret = debounceAsync(() => {
        return actions.createStripeSetupIntent()
            .then(res => setClientSecret(res.clientSecret))
            .catch(e => log.e('fetchClientSecret', e))
    })
    
    // @todo changing the theme doesn't auto update here yet
    const options = useMemo(() => (
        !clientSecret?.length ? null : {
            ...stripeConfigs.getStripeElementsOptions(),
            clientSecret,
        }
    ), [theme, clientSecret])
    
    useEffect(() => {
        
        // Stripe must be initialized & ready
        if (!remoteConfig?.stripe?.enabled)
            return
        
        // Config must be loaded to use the public key
        if (!stripePromise)
            setStripePromise(loadStripe(config.stripePublicKey))
        
        // Fetch the client secret from our API
        if (!clientSecret?.length)
            fetchClientSecret()
        
    }, [theme, remoteConfig, clientSecret])
    
    if (!stripePromise || !clientSecret?.length || !options)
        return <CircleSpinner />
    
    return (
        <Elements stripe={stripePromise} options={options}>
            {children}
        </Elements>
    )
    
}
